import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { PriceListDetailModel } from 'src/app/models/archive/price-list-detail.model';
import { PriceListModel } from 'src/app/models/archive/price-list.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { PriceListDetailCaptureTableModel } from 'src/app/models/tables/archive/price-list-detail-capture-table.model';
import { PriceListDetailService } from 'src/app/services/archive/price-list-detail.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ImportPriceListComponent } from '../../price-list/import-price-list/import-price-list.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-price-list-detail',
  templateUrl: './price-list-detail.component.html',
  styleUrls: ['./price-list-detail.component.scss'],
  standalone: false
})
export class PriceListDetailComponent implements OnInit, OnChanges {

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('priceListDetailImportModal') priceListDetailImportModalComponent?: CustomModalComponent | null = null;

  @Input() disabledDetail: boolean = false;
  @Input() permissionUpdatable: boolean = false;
  @Input() priceListModel: PriceListModel = new PriceListModel();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentPriceListDetailImportModal = ImportPriceListComponent;
  componentTableSelection = CustomTableSelectComponent;
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  detailData: PagedResponseModel<PriceListDetailCaptureTableModel> = new PagedResponseModel<PriceListDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  filters: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  inputsForImportModal$ = new BehaviorSubject<any>({
    priceListId: 0,
    priceListCode: 0
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  priceListDetailModel: PriceListDetailModel = new PriceListDetailModel();
  subscription: Subscription;
  tableActions: TableAction[] = [];
  userAuthenticated: UserModel = new UserModel();

  constructor(private confirmDialogService: ConfirmDialogService,
    private optionWindowService: OptionWindowService,
    private priceListDetailService: PriceListDetailService,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService) { }

  async ngOnInit(): Promise<void> {
    this.getPermissionsForUserByWindow();
    await this.getColumns();
    await this.getColumnsArticle();
    this.tableActions = this.getDefaultActions();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeArticle(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const priceListModel = changes["priceListModel"];
    if (priceListModel && !priceListModel.firstChange) {
      this.getFormView(false);
      this.getPriceListDetails();
      this.priceListDetailModel = new PriceListDetailModel();

      const isNewOrClosed = this.priceListModel.priceListId === 0;
      this.disabledButton = isNewOrClosed;
    }

    const disabledDetail = changes["disabledDetail"];
    if (disabledDetail && !disabledDetail.firstChange) {
      this.tableActions = this.getDefaultActions();
    }
  }

  async deletePriceListDetail(selectedIds: number[]) {
    if (await this.confirmDialogService.confirm(
      "¿Realmente desea eliminar el detalle de la lista de precios?"
    )) {
      try {
        await firstValueFrom(this.priceListDetailService.deletePriceListDetail(selectedIds));
        this.toastHandlerService.showToast(
          'success',
          'El detalle de la lista de precios fue eliminado exitosamente.'
        );
        this.priceListDetailModel = new PriceListDetailModel();
        this.clearSelectionTrigger++;
        this.getFormView(false);
        await this.getPriceListDetails();
      } catch (error) {
        console.error('Error al eliminar el detalle de la lista de precios.', error);
      }
    }
  }

  async editPriceListDetail(item: PriceListDetailCaptureTableModel) {
    try {
      const response = await firstValueFrom(this.priceListDetailService.getPriceListDetailById(item.id));
      if (response) {
        this.priceListDetailModel = response;
      }
      this.getFormView(true);
    } catch (error) {
      console.error('Error al buscar el detalle de la lista de precios.', error);
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.priceListDetailService.getColumnsForCaptureTable());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length != 0) return;
      this.headerArticle = await firstValueFrom(this.priceListDetailService.getColumnsForArticleSelection());
      this.updateInputs();
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (this.disabledDetail) {
      return [];
    } else {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getListArticlesForSelection() {
    try {
      this.dataArticle = await firstValueFrom(
        this.priceListDetailService.getListArticlesForSelection(
          this.priceListModel.priceListId, this.pageArticle, this.limitArticle,
          this.columnSortArticle, this.ascendantArticle, this.filtersArticle
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable
      .pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.PriceList));
  }

  async getPriceListDetails() {
    try {
      this.detailData = await firstValueFrom(
        this.priceListDetailService.getPriceListDetailsForCaptureTable(
          this.page, this.limit, this.columnSort, this.ascendant, this.priceListModel.priceListId, this.filters
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al buscar los detalles de la lista de precios.', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para la edición de listas de precios. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    const textMessage = selectedItem.length === 1
      ? '¿Realmente desea agregar el artículo seleccionado?'
      : '¿Realmente desea agregar los artículos seleccionados?';

    if (await this.confirmDialogService.confirm(textMessage)) {
      if (selectedItem.length == 1) {
        const articleId = parseInt(selectedItem[0]?.id);
        const response = await firstValueFrom(this.priceListDetailService.getPriceListDetailByKeys(
          this.priceListModel.priceListId, articleId
        ));
        if (response.priceListDetailId === 0) {
          this.priceListDetailModel = new PriceListDetailModel();
          this.priceListDetailModel.articleId = articleId;
          this.priceListDetailModel.rateDiscount = this.priceListModel.rateDiscount;
        } else {
          this.priceListDetailModel = new PriceListDetailModel();
          this.priceListDetailModel.articleId = articleId;
          this.priceListDetailModel.baseUnitValue = response.baseUnitValue;
          this.priceListDetailModel.rateDiscount = this.priceListModel.rateDiscount;
          this.priceListDetailModel.clientUnitValue =
            (response.clientUnitValue - ((response.clientUnitValue * this.priceListModel.rateDiscount) / 100));
        }
        this.clearSelectionTrigger++;
        this.getFormView(true);
      } else {
        const articleIds = selectedItem.map((element: { articleId: number; }) => element.articleId);
        await firstValueFrom(this.priceListDetailService.createSomePriceListDetail(this.priceListModel.priceListId, articleIds));
        await this.getPriceListDetails();
        this.toastHandlerService.showToast(
          'success',
          'Los artículos fueron agregados exitosamente'
        );
      }
    }
  }

  async onAction(event: { action: string, item?: PriceListDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      await this.editPriceListDetail(event.item);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deletePriceListDetail(event.selectedItems);
    }
  }

  async onExport() {
    if (this.detailData.totalItems === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No hay datos para exportar.'
      );
      return;
    }
    try {
      const response = await firstValueFrom(
        this.priceListDetailService.exportCaptureDetailConsultation(
          this.filters, this.columnSort, this.ascendant, this.priceListModel.priceListId
        )
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Listas de precios Detalles.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar el detalle de las listas de precios.', error);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onFilterChangeArticle(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilterArticle(filter));
    this.updateInputs();
  }

  async onImport() {
    if (this.priceListModel.priceListId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear la lista de precios antes de importar detalles.'
      );
      return;
    }

    const hasImportPermission =
      this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador ||
      this.permissionsUser.find(x => x.code == OptionWindow.Importar);

    if (!hasImportPermission) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para importar listas de precios, comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para la edición de listas de precios. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    this.priceListDetailImportModalComponent?.show();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getPriceListDetails();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getListArticlesForSelection();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    this.updateInputs();
    await this.getListArticlesForSelection();
    this.articleSelectionModalComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  processFilterArticle(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadList(reload: boolean) {
    if (reload) {
      await this.getPriceListDetails();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
    this.inputsForImportModal$.next({
      priceListId: this.priceListModel.priceListId,
      priceListCode: this.priceListModel.code
    });
  }

}
